import React from "react";
import Context from "../../../../../../context";

import {
  CustomBadges,
  CustomIcon,
  CustomSubLogin,
  TableNullData,
  UserInformation,
} from "../../../../../../components";

import "./index.scss";
import Cookies from "js-cookie";
import values from "../../../../../../values";
import utils from "../../../../../../utils";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {
  const { setShowModal, setSelectedSuperAgent } = React.useContext(
    Context.SuperAgentProvinceScreen
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(values.constants.USER.TYPE)
  );

  function onUpdate(superAgent: any) {
    setSelectedSuperAgent(superAgent);
    setShowModal("UPDATE");
  }

  // function onDelete(superAgent: any) {
  //   setSelectedSuperAgent(superAgent);
  //   setShowModal("DELETE");
  // }

  const { t } = useTranslation();

  // ========================================== JSX Content =============================================
  const showInformation = (user: any) => {
    setSelectedSuperAgent(user);
    setShowModal("SHOW_INFORMATION");
  };

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="super-agent-table-body-content">
      {data?.map((superAgent: any, index: number) => {
        return (
          <tr key={`superAgent-${index}`}>
            {/* SuperAgent Information */}
            <td onClick={() => showInformation(superAgent)}>
              <UserInformation
                name={superAgent?.provinceEducationInformation?.name}
                phoneNumber={superAgent?.phoneNumber}
              />
            </td>
            {/* actions */}
            <td>
              <CustomBadges
                title={superAgent?.provinceEducationInformation?.province?.Name}
                type="primary"
              />
            </td>

            <td>
              {writePermission === "true" && (
                <div className="table-actions-buttons">
                  {/* Edit Icon */}
                  <CustomIcon
                    icon="fas fa-pen"
                    hoverTitle={t("educationName")}
                    onClick={() => onUpdate(superAgent)}
                  />
                  {userType === "ADMIN" && (
                    <CustomSubLogin userId={superAgent._id} />
                  )}
                  {/* Delete Modal */}
                  {/* <CustomIcon icon="fas fa-trash" hoverTitle="حذف" onClick={() => onDelete(superAgent)} /> */}
                  {/* Block Icon */}
                  {/* <CustomIcon icon="fas fa-ban" hoverTitle="مسدود کردن" onClick={() => console.log("Block")} /> */}
                  {/* Block-Reason Icon */}
                  {/* {superAgent?.blocks.length > 0 && (
                  <CustomIcon icon="fas fa-shield-xmark" hoverTitle="دلیل مسدودی" onClick={() => console.log("Reason")} />
                )} */}
                </div>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
